import { IAppState } from '../../common/state';

export function selectTravelTime(state: IAppState): number | undefined {
  return state.filters.jsonQuery.foot_min && state.filters.jsonQuery.foot_min.value.lte;
}
